import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TreeView from '@mui/lab/TreeView';
import { SvgIconProps } from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import React, { useEffect } from 'react';
import OrganizationItemIcon from '../../../assets/rolebrowser/OrganizationItemIcon';
import TreeItem from './TreeItems/StyledTreeItem';

interface Hierarchy {
  id: string;
  name: string;
  children?: Hierarchy[];
}

interface HierarchyTreeProps {
  data: Hierarchy[];
  childOnClick: Function;
  parentOnClick: Function;
  ChildIcon: React.ElementType<SvgIconProps<'svg', {}>>;
  selectedIds?: (string | undefined)[];
}

const HierarchyTree = ({
  data,
  childOnClick,
  parentOnClick,
  ChildIcon,
  selectedIds
}: HierarchyTreeProps) => {
  useEffect(() => {
    const selected = document.getElementById('selected-hierarchy-tree-item');
    if (selected) {
      selected.scrollIntoView();
      window.scrollTo(0, 0);
    }
  }, []);

  const ids = [] as Array<string>;
  const renderTree =
    (parentId: string) =>
    ({ children, ...rest }: Hierarchy) => {
      const selected = !!selectedIds?.find(id => id === rest.id);
      ids.push(`${rest.id}-${parentId}`);
      return (
        <TreeItem
          id={(selected && 'selected-hierarchy-tree-item') || `${rest.id}-${parentId}`}
          data-testid={`hierarchy-tree-item-${parentId}`}
          data-id={`${rest.id}`}
          key={`${rest.id}-${parentId}`}
          nodeId={`${rest.id}-${parentId}`}
          onLabelClick={event => {
            event.preventDefault();
            return parentId === 'root' || children?.length
              ? parentOnClick(rest)
              : childOnClick({ ...rest, parentid: [parentId] });
          }}
          selected={selected}
          labelText={rest.name}
          labelIcon={parentId === 'root' || children?.length ? OrganizationItemIcon : ChildIcon}
        >
          {children?.map(node => renderTree(rest.id)(node)) || null}
        </TreeItem>
      );
    };

  return data.length > 0 ? (
    <TreeView
      data-testid="hierarchy-tree"
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      defaultExpanded={ids}
      disableSelection
      sx={{ height: '100%', padding: 1 }}
    >
      {data.map(item => renderTree('root')(item))}
    </TreeView>
  ) : (
    <Typography variant="body2" style={{ marginTop: 8 }}>
      No data
    </Typography>
  );
};

export default HierarchyTree;
